import { Globe2 } from 'lucide-react'
import { t } from '../i18n'
import { GULF_PLAN_CURRENCIES } from '../config/planCurrencies'

export default function PlanCurrencySelector({ country, onChange, className = '' }) {
  return (
    <div className={`rounded-2xl border border-blue-100 bg-blue-50/70 p-4 ${className}`}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-white text-blue-700 ring-1 ring-blue-100" aria-hidden="true">
            <Globe2 className="h-5 w-5" />
          </span>
          <div>
            <p className="font-semibold text-slate-900">{t('Want to see prices in your local currency?')}</p>
            <p className="mt-0.5 text-sm text-slate-600">{t('Choose your Gulf country and we will show an estimated local price.')}</p>
          </div>
        </div>
        <label className="shrink-0">
          <span className="sr-only">{t('Choose your country')}</span>
          <select
            value={country || ''}
            onChange={event => onChange(event.target.value)}
            className="min-h-11 w-full cursor-pointer rounded-xl border border-slate-300 bg-white px-4 py-2.5 font-medium text-slate-900 outline-none transition-colors focus:border-blue-600 focus:ring-2 focus:ring-blue-200 sm:w-60"
          >
            <option value="">{t('Prices in USD')}</option>
            {GULF_PLAN_CURRENCIES.map(item => (
              <option key={item.country} value={item.country}>{t(item.name)} — {item.currency}</option>
            ))}
          </select>
        </label>
      </div>
      {country && <p className="mt-3 text-xs text-slate-500">{t('Local prices are estimates. Your final invoice uses the plan billing currency and current payment rate.')}</p>}
    </div>
  )
}
